// extracted by mini-css-extract-plugin
module.exports = {"policiesLinks":"policieslinks_policiesLinks__3uv6c","link":"policieslinks_link__B84J6"};